import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface HumanName {
  title?: string;
  lastName: string;
  firstName: string;
  display: string;
  fullName: string;
  acronym: string;
}

export const getAcronymFromName = (name: string = ''): string => {
  name = name.split('@')[0];

  const names = (name?.replace(/\./g, '. ').split(' ') || []).filter(
    (n) => !n.includes('.'),
  );

  while (names.length < 2) names.push('');

  const firstName = names[0];
  const lastName = names.pop();

  return (firstName.charAt(0) || '') + (lastName.charAt(0) || '');
};

@Injectable({
  providedIn: 'root',
})
export class HumanNameAdapter {
  fromResource$(
    fhirName: fhir4.HumanName | fhir4.HumanName[],
    use: fhir4.HumanName['use'] = 'official',
  ): Observable<HumanName> {
    const _resource = Array.isArray(fhirName)
      ? fhirName.find((name: fhir4.HumanName) => name.use === use) ||
        fhirName[0]
      : fhirName || {};

    const title = _resource.prefix?.join(' ');
    const firstName = _resource.given?.join(' ') || '';
    const lastName = _resource.family || '';
    const display = _resource.text || `${firstName} ${lastName}`;
    const fullName = [title, firstName, lastName].filter((x) => x).join(' ');
    const acronym = (firstName.charAt(0) || '') + (lastName.charAt(0) || '');

    const nameDetails = {
      title,
      lastName,
      firstName,
      display,
      fullName,
      acronym,
    };

    return of(nameDetails);
  }
}
